export enum AccessType {
  SLEUTEL = "Sleutel",
  ANALOOG = "Analoog",
  DIGITAAL = "Digitaal",
  HANGSLOT = "Hangslot",
}

export const ACCESS_TYPE_LABELS: Record<AccessType, string> = {
  [AccessType.SLEUTEL]: "Sleutel",
  [AccessType.ANALOOG]: "Analoog",
  [AccessType.DIGITAAL]: "Digitaal",
  [AccessType.HANGSLOT]: "Hangslot",
};

export const ACCESS_TYPE_COLORS: Record<AccessType, string> = {
  [AccessType.SLEUTEL]: "bg-moss-secondary-light text-moss-primary",
  [AccessType.ANALOOG]: "bg-brick-secondary-light text-brick-primary",
  [AccessType.DIGITAAL]: "bg-yellow-secondary-light text-yellow-primary",
  [AccessType.HANGSLOT]: "bg-neutral-secondary-light text-neutral-primary",
};

export enum KeyLocation {
  BIJ_GEBOUW = "Bij gebouw",
  OP_KANTOOR = "Op kantoor",
  LEVERANCIER = "Leverancier",
  MAKELAAR = "Makelaar",
}

export const KEY_LOCATION_LABELS: Record<KeyLocation, string> = {
  [KeyLocation.BIJ_GEBOUW]: "Bij gebouw",
  [KeyLocation.OP_KANTOOR]: "Op kantoor",
  [KeyLocation.LEVERANCIER]: "Leverancier",
  [KeyLocation.MAKELAAR]: "Makelaar",
};

export interface AccessControlItem {
  id: number;
  buildingId: string;
  unitId: string | null;
  accessType: AccessType | null;
  keyLocation: KeyLocation | null;
  additionalInfo: string | null;
  building?: { id: string };
  unit?: { id: string } | null;
}
